import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import formatDate from '../../../../../frontend/components/components/utils/formatDate';

function CampaignCanceled({ offer = {}, userOffer = {} }) {
  const { t } = useTranslation();

  return <div className="campaign-canceled">
    <Container>
      <Row>
        <Col>
          <h4>
            {t('influencers.pages.campaign.campaign_canceled.title')}
          </h4>
        </Col>
      </Row>

      <Row>
        <Col>
          <p>
            {t('influencers.pages.campaign.campaign_canceled.text')} {offer.csa_email}
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p>
            {t('influencers.pages.campaign.campaign_canceled.quit')} {formatDate(userOffer.canceled_at)}
          </p>
        </Col>
      </Row>
    </Container>
  </div>;
}

export default CampaignCanceled;
